<template>
  <div  class="card">
    <div class="content"  v-if="mode=='success'">
      <img src="./img/evaluation_success.png" alt="错误图片">
      <p>老师已经收到你的评价啦</p>
      <p>非常感谢你的积极反馈，我们会继续加油的！</p>
    </div>
    <div class="content" v-else>
      <img src="./img/evaluation_fail.png" alt="错误图片">
      <p>啊哦，出错了</p>
      <p>不要着急，再试一次就好了</p>
    </div>

  </div>
</template>
<script>
export default {

  props: {
    mode: {
      type: String,
      required: true,
      validator: value => {
        if (["success", "fail"].includes(value)) {
          return true;
        } else {
          console.error("the value have to be a type of a or B");
          return false;
        }
      }
    },
    autoClosed: {
      type: Boolean,
      default: false
    },
    closedTime: {
      type: Number,
      default: 3000,
      required: false
    },
  },
  mounted() {
    setTimeout(() => {
      this.$emit("cardCallBack",this.mode);
    }, 3000);
  },

};
</script>
<style lang="less" scoped>
.card {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    background: #fff;
    width: 490px;
    height: 356px;
    border-radius: 15px;
    padding-top: 54px;
    img {
      margin-bottom: 48px;
      width: 164px;
      height: 136px;
    }
    p {
      &:nth-child(2) {
        font-family: PingFang_Medium;
        font-size: 24px;
        color: #003057;
        line-height: 24px;
        margin-bottom: 12px;
      }
      &:nth-child(3) {
        font-family:  PingFang_Regular;
        font-size: 16px;
        color: #003057;
        letter-spacing: 0;
        line-height: 16px;
      }
    }
  }
}
</style>








// WEBPACK FOOTER //
// src/components/basic/card/card.vue